export default function sendMetaPixelEvent(eventName, eventId, eventData = {}) {
  if (typeof window === "undefined" || !window.fbq) {
    return;
  }
  window.fbq(eventName, eventId, eventData);
}